import { useCallback, useRef } from 'react';
export function useShapeMove({ selectedIds, dispatch, containerWidth, containerHeight }) {
    const moveState = useRef(null);
    const startMove = useCallback((clientX, clientY) => {
        moveState.current = { startX: clientX, startY: clientY, lastDx: 0, lastDy: 0 };
    }, []);
    const onMovePointer = useCallback((clientX, clientY) => {
        const state = moveState.current;
        if (!state || containerWidth === 0 || containerHeight === 0)
            return;
        const totalDxNorm = (clientX - state.startX) / containerWidth;
        const totalDyNorm = (clientY - state.startY) / containerHeight;
        const incrementDx = totalDxNorm - state.lastDx;
        const incrementDy = totalDyNorm - state.lastDy;
        if (incrementDx === 0 && incrementDy === 0)
            return;
        state.lastDx = totalDxNorm;
        state.lastDy = totalDyNorm;
        dispatch({
            type: 'MOVE_SHAPES',
            ids: Array.from(selectedIds),
            dx: incrementDx,
            dy: incrementDy,
        });
    }, [selectedIds, containerWidth, containerHeight, dispatch]);
    const endMove = useCallback(() => {
        moveState.current = null;
    }, []);
    const nudge = useCallback((dx, dy) => {
        if (selectedIds.size === 0 || containerWidth === 0 || containerHeight === 0)
            return;
        dispatch({
            type: 'MOVE_SHAPES',
            ids: Array.from(selectedIds),
            dx: dx / containerWidth,
            dy: dy / containerHeight,
        });
    }, [selectedIds, containerWidth, containerHeight, dispatch]);
    const isMoving = useCallback(() => moveState.current !== null, []);
    return { startMove, onMovePointer, endMove, nudge, isMoving };
}
